import { configureStore, injectStore } from 'getaway-data-layer';

export const { store, persistor } = configureStore();
injectStore(store, persistor);
